/**
 * @deprecated
 * @description
 * This is a deprecated enum.
 */
export var ToggleVariantType;
(function (ToggleVariantType) {
    ToggleVariantType["REGULAR"] = "REGULAR";
})(ToggleVariantType || (ToggleVariantType = {}));
export var ToggleWithLabelVariantType;
(function (ToggleWithLabelVariantType) {
    ToggleWithLabelVariantType["REGULAR"] = "REGULAR";
})(ToggleWithLabelVariantType || (ToggleWithLabelVariantType = {}));
//# sourceMappingURL=variants.js.map